/*=========================================================================================
  File Name: moduleSigepMutations.js
  Description: Sigep Module Mutations
==========================================================================================*/

export default {
  SET_INFO(state, info) {
    state.info = info
  },
  
  UPDATE_INFO(state, info) {
    state.info = info
  },

}